import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'

import * as styles from './index.module.css'

export default ({ title, images, subtitle }) => {
  const fragments = subtitle.subtitle.split('\n')
  return (
    <div className="wrapper">
      <div className={styles.container}>
        <div className={styles.textBox}>
          <h1 className={styles.title}>{title}</h1>
          {typeof window !== `undefined` && window.innerWidth <= 450 && (
            <div className={styles.imageBox}>
              <GatsbyImage
                image={images[0].gatsbyImageData}
                style={{ height: '100%', width: '100%' }}
                alt={images[0]?.description}
              />
            </div>
          )}
          <div className={styles.definition}>
            <h2 className="inline-block">{fragments[0]}</h2>
            <span className={`${styles.noun} ${styles.bottomAlign}`}>
              {fragments[1]}
            </span>
            <span className={`${styles.phonetic} ${styles.bottomAlign}`}>
              \ ˈau̇-stərs \
            </span>
            <ol className={`steps ${styles.defList}`}>
              {fragments.slice(2).map((item, idx) => (
                <li className={styles.defItem} key={idx}>
                  {item}
                </li>
              ))}
            </ol>
          </div>
        </div>
        {typeof window !== `undefined` && window.innerWidth > 450 && (
          <div className={styles.imageBox}>
            <GatsbyImage
              image={images[0].gatsbyImageData}
              style={{ height: '100%', width: '100%', position: 'absolute' }}
              alt={images[0]?.description}
            />
          </div>
        )}
      </div>
    </div>
  )
}
